const tags = {
    // ======================
    // CORE WEB
    // ======================
    html: "HTML",
    css: "CSS",
    javascript: "JavaScript",
    typescript: "TypeScript",
    php: "PHP",

    // ======================
    // FRONTEND FRAMEWORKS
    // ======================
    react: "React",
    nextjs: "Next.js",
    vite: "Vite",

    // State & Data
    redux: "Redux",
    axios: "Axios",
    i18next: "i18next",

    // ======================
    // UI / DESIGN / UX
    // ======================
    mui: "MUI",
    tailwind: "Tailwind CSS",
    bootstrap: "Bootstrap",
    shadcn: "ShadCN UI",
    swiper: "Swiper.js",
    framer: "Framer Motion",
    moment: "Moment.js",

    // UI Features
    responsive: "Responsive Design",
    dashboard: "Dashboard",
    animations: "Animations",
    dragDrop: "Drag & Drop",
    gallery: "Image Gallery",
    darkMode: "Dark Mode Support",

    // ======================
    // BACKEND FRAMEWORKS
    // ======================
    node: "Node.js",
    express: "Express",
    nestjs: "NestJS",
    laravel: "Laravel",
    fastapi: "FastAPI",

    // Backend Concepts
    api: "API Integration",
    crud: "CRUD",
    auth: "Authentication",
    authorization: "Authorization",
    validation: "Validation",
    realtime: "Realtime",
    notifications: "Notifications",

    // ======================
    // DATABASE & STORAGE
    // ======================
    mysql: "MySQL",
    postgres: "PostgreSQL",
    mongodb: "MongoDB",
    neon: "Neon Postgres",

    firebase: "Firebase",
    firestore: "Firestore",
    storage: "Cloud Storage",
    nosql: "NoSQL Database",

    // Database Features
    search: "Search & Filter",
    offline: "Offline Support",

    // ======================
    // CMS / CONTENT / SOCIAL
    // ======================
    cms: "CMS",
    blog: "Blog",
    markdown: "Markdown Editor",
    chat: "Chat System",

    // ======================
    // INTEGRATIONS
    // ======================
    maps: "Maps Integration",
    calendar: "Calendar Integration",
    reactQr: "React QR Code",

    // ======================
    // E-COMMERCE
    // ======================
    ecommerce: "E-Commerce",
    stripe: "Stripe Payments",
    checkout: "Checkout Flow",

    // ======================
    // PRODUCTIVITY / UTILITIES
    // ======================
    productivity: "Productivity",
    notes: "Note Taking",
    clipboard: "Clipboard",
    chrome: "Chrome Extension",
    edu: "Education",
    qr: "QR Code",
    barcode: "Barcode Scanner",
    utility: "Utilities",

    // ======================
    // DEPLOYMENT & DEVOPS
    // ======================
    vercel: "Vercel",
    netlify: "Netlify",
    docker: "Docker",
    github: "GitHub",
    git: "Git",
    ci: "CI/CD",
    env: "Environment Config",
    hosting: "Hosting",

    // ======================
    // AI / ML
    // ======================
    ai: "AI Powered",
    computerVision: "Computer Vision",
    yolo: "YOLOv8",
    openai: "OpenAI API",
    llm: "LLM Integration",
    automation: "Automation",

    // ======================
    // PROJECT TYPES
    // ======================
    portfolio: "Portfolio Project",
    webApp: "Web Application",
    fullstack: "Full Stack",
    cloudApp: "Cloud Application",
    landing: "Landing Page",
    adminPanel: "Admin Dashboard",
    mobileFirst: "Mobile First",
    saas: "SaaS Platform",
    startup: "Startup Project",

    localStorage: "Local Storage",
    fileManager: "File Management",
    workspace: "Workspace Tool",
    textEditor: "Text Editor",
    materialDesign: "Material Design",

    simulation: "Simulation",
    algorithm: "Algorithm",
    visualization: "Data Visualization",
    cryptography: "Cryptography",
    encryption: "Encryption",
    cipher: "Cipher Systems",
    interactive: "Interactive UI",
    customUI: "Custom UI",
    realtimeAnimation: "Realtime Animation",
};

export default tags;
